module.exports = __webpack_public_path__ + "static/media/close.1d417adf.svg";